import { addStyleByPredicate } from "../../helpers/helpers";
export var addFocusedStyle = addStyleByPredicate(function (_ref) {
  var focused = _ref.focused;
  return focused;
});
export var addErrorStyle = addStyleByPredicate(function (_ref2) {
  var error = _ref2.error;
  return error;
});
export var addErrorFocusedStyle = addStyleByPredicate(function (_ref3) {
  var error = _ref3.error,
      focused = _ref3.focused;
  return error && focused;
});
export var addDisabledStyle = addStyleByPredicate(function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled;
});
export var addHoverStyle = addStyleByPredicate(function (_ref5) {
  var disabled = _ref5.disabled,
      focused = _ref5.focused;
  return !disabled && !focused;
});